import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { DeliveryNoteNotificationsService } from './delivery-note-notifications.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Error, CustomHttpErrorResponse, NotificationService } from '../../../../../common';
import {
  DeliveryNoteNotificationsInitialState,
  DeliveryNoteNotificationsLoad,
} from './delivery-note-notifications.actions';
import { LatestNotification } from '../../../monitoring/models';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface DeliveryNoteNotificationsStateModel {
  notifications: LatestNotification[];
  loaded: boolean;
}

const initialState: DeliveryNoteNotificationsStateModel = {
  notifications: [],
  loaded: false,
};

@State<DeliveryNoteNotificationsStateModel>({
  name: 'deliveryNoteNotifications',
  defaults: initialState,
})
@Injectable()
export class DeliveryNoteNotificationsState {
  constructor(
    private deliveryNoteNotificationsService: DeliveryNoteNotificationsService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getLoaded(state: DeliveryNoteNotificationsStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getNotifications(state: DeliveryNoteNotificationsStateModel): LatestNotification[] {
    return state.notifications;
  }

  @Action(DeliveryNoteNotificationsLoad)
  getDeliveryNoteNotifications(
    ctx: StateContext<DeliveryNoteNotificationsStateModel>,
    { payload }: DeliveryNoteNotificationsLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.deliveryNoteNotificationsService.getNotifications(payload).pipe(
      map((notifications: LatestNotification[]) => {
        ctx.patchState({ notifications, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(DeliveryNoteNotificationsInitialState)
  setInitialState(ctx: StateContext<DeliveryNoteNotificationsStateModel>): void {
    ctx.setState(initialState);
  }
}
